import { Alert, Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { PageTopBar, TwoSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import { CopiaChecklistEntregaAmbienteModal } from "./components/copia_checklist_entrega_ambiente_modal"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import { GenerateChecklistEntregaAmbienteColumns } from "./columns"
import { CadastroChecklistEntregaAmbienteModal } from "./components/cadastro_checklist_entrega_ambiente_modal"
import { ChecklistEntregaAmbienteModel } from "../../../domain/models/checklist_entrega_ambiente"
import { useChecklistEntregaAmbienteListaViewModel } from "../../viewModels/checklist_entrega_lista_ambiente_view_model"
import { Link as LinkTo } from "react-router";
import { BackButton } from "../../../../../common/components/back_button"


export const ChecklistEntregaAmbienteLista = () => {
    const viewModel = useChecklistEntregaAmbienteListaViewModel();

    const columnsDef = useMemo(() => {
        return GenerateChecklistEntregaAmbienteColumns({
            onActionEdit: viewModel.handleChecklistEntregaAmbienteOpenState,
            onActionDelete: viewModel.handleChecklistEntregaAmbienteDeleteOpenState,
            onActionCopia: viewModel.handleChecklistEntregaAmbienteCopiaOpenState,
            onActionItens: viewModel.handleEditItens,
        });
    }, [
        viewModel.handleChecklistEntregaAmbienteOpenState,
        viewModel.handleChecklistEntregaAmbienteDeleteOpenState,
        viewModel.handleChecklistEntregaAmbienteCopiaOpenState,
        viewModel.handleEditItens,
    ]);

    return (
        <>
            <PageTopBar>
                <TwoSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">
                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleChecklistEntregaAmbienteOpenState(null, true)}>
                                    Novo Ambiente
                                </PrimaryButton>
                            </div>
                            <div>
                                <BackButton onClick={viewModel.handleBack} />
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-3 flex-col py-5 px-4">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Link underline="hover" color="inherit" component={"span"}>
                        <LinkTo to="/ChecklistEntrega_lista">Checklist de Entrega de Obras Lista</LinkTo>
                    </Link>
                    <Typography className="text-primary-green">
                        Ambiente Checklist de Entrega
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-3 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Ambiente Checklist de Entrega</h1>
                        <p>Pesquisar </p>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>
                </div>
                <div>
                    <div className="flex flex-row gap-8">
                        {/* <div className="flex flex-row text-black dark:text-white items-center">
                            <span className="font-extrabold text-xl mr-2">Área: </span>
                            <span className="mx-1 font-base text-base">{viewModel.obraChecklistServicoHeader.descricaoArea}</span>
                        </div> */}
                        <div className="flex flex-row text-black dark:text-white items-center">
                            <span className="font-extrabold text-xl mr-2">Checklist: </span>
                            <span className="mx-1 font-base text-base">{(viewModel.selectedChecklistEntrega?.codigo + ' - ' + viewModel.selectedChecklistEntrega?.descricao) || '-'}</span>
                        </div>
                    </div>
                </div>
                <div className="flex gap-2 items-center w-full">
                    {/* iNFORMAÇÕES DO CHECKLIST DE SERVIÇO SELECIONADO */}
                    {
                        viewModel.selectedChecklistEntrega &&
                        <div className="w-full flex flex-col gap-0">
                            <div className="w-full flex flex-row items-center">
                                <span className="text-black dark:text-white font-bold text-lg">
                                    {viewModel.selectedChecklistEntrega.codigo} | {viewModel.selectedChecklistEntrega.descricao}
                                </span>
                            </div>
                        </div>
                    }
                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                descricao={viewModel.filters.descricao}
                                handleDescricaoChange={viewModel.handleDescricaoChange}
                                onClearFilters={viewModel.handleClearFilters}
                            />

                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="Clientes_Lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: ChecklistEntregaAmbienteModel) => row.idChecklistEntregaAmbiente}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={false}
                                    rows={viewModel.checklistEntregaAmbienteLista}
                                    rowCount={viewModel.checklistEntregaAmbienteLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        right: ['idChecklistEntregaAmbiente', 'acoes'],
                                    }}
                                    getRowHeight={() => 'auto'}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>


                        </>
                    )
                }
            </div >

            <DeleteDialog
                open={viewModel.openDeleteModal}
                onClose={() => viewModel.handleChecklistEntregaAmbienteDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este item?`}
                onDelete={viewModel.handleConfirmarDeletarChecklistEntregaAmbiente}
            />

            <CopiaChecklistEntregaAmbienteModal
                open={viewModel.openCopiaModal}
                saving={viewModel.saving}
                selectedChecklistEntregaAmbiente={viewModel.selectedChecklistEntregaAmbiente}
                onClose={() => viewModel.handleChecklistEntregaAmbienteCopiaOpenState(null, false)}
                onSubmit={viewModel.handleSubmitChecklistEntregaAmbienteCopia}
            />

            <CadastroChecklistEntregaAmbienteModal
                open={viewModel.openCadastroModal}
                saving={viewModel.saving}
                loading={viewModel.loading}
                handleOpenChangeHistory={viewModel.handleOpenChangeHistory}
                selectedChecklistEntregaAmbiente={viewModel.selectedChecklistEntregaAmbiente}
                onClose={() => viewModel.handleChecklistEntregaAmbienteOpenState(null, false)}
                onSubmit={viewModel.handleSubmitChecklistEntregaAmbiente}

            />

            <ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory} />

        </>
    )
}
